//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../Join/Join.JoinBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/Section.js";
let d=[[[0,"BoundaryMethod",1,0],[0,"Corner1",1,"Point",0],[0,"Corner2",1,"Point",0],[1,"FaceCollector",0,"ScCollector",0],[0,"HolesCoverage",1,0],[0,"InnerBoundary",0,"Section",0],[0,"OrientationType",1,0],[0,"OrientationVector",1,"TaggedObject",0],[0,"OuterBoundary",0,"Section",0],[0,"VisualizationColor",1,0],[0,"VisualizationLocation",1,0],[1,"VisualizationThickness",0,"Expression",0],[0,"VisualizationType",1,0]],[],[]];
SPLM.Join.FaceJoinBuilder = class extends SPLM.Join.JoinBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.FaceJoinBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.FaceJoinBuilder.HolesCoverageType = Object.freeze({
    "CoverTop" : "CoverTop", "FillInside" : "FillInside", "DoNotCover" : "DoNotCover"});

SPLM.Join.FaceJoinBuilder.VisualizationBodyType = Object.freeze({
    "None" : "None", "SolidBody" : "SolidBody", "SheetBody" : "SheetBody"});

SPLM.Join.FaceJoinBuilder.VisualizationLocationType = Object.freeze({
    "AboveFace" : "AboveFace", "BelowFace" : "BelowFace", "AboveBelowFace" : "AboveBelowFace"});

SPLM.Join.FaceJoinBuilder.BoundaryMethodType = Object.freeze({
    "Automatic" : "Automatic", "Rectangle" : "Rectangle", "Curve" : "Curve"});

SPLM.Join.FaceJoinBuilder.OrientationTypes = Object.freeze({
    "NormalSelectedFace" : "NormalSelectedFace", "AlongVector" : "AlongVector"});

export default SPLM;